import { render } from "./PageHeaderVenue.vue?vue&type=template&id=f2bc386c"
import script from "./PageHeaderVenue.js?vue&type=script&lang=js"
export * from "./PageHeaderVenue.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__